export default "__VITE_ASSET__442ba86e__"